import React from 'react'
import moment from 'moment'
import Type from '@/component/Primitive/Type'
import styles from './MediaVersionContent.module.scss'
import mediaVersionPropTypes from '@/shape/media-version'
import Grid from '@/component/Primitive/Grid'
import { shape, bool } from 'prop-types'
import classNames from 'classnames'

const MediaVersionContent = ({ details, designV2 }) => {
  return (
    <div
      className={classNames(
        styles.MediaVersionContent,
        designV2 && styles.DesignV2
      )}
    >
      <Grid>
        {details.classificationDate && (
          <Grid.Item className={styles.GridItem} width={[1, 1, 1 / 2]}>
            <Type bold className={styles.Title}>
              Classified Date:{' '}
            </Type>
            <Type color="teal" className={styles.MediaVersionData}>
              {details.classificationDate
                ? moment(details.classificationDate).format('DD/MM/YYYY')
                : ''}
            </Type>
          </Grid.Item>
        )}
        {details.version && !details.episode && (
          <Grid.Item className={styles.GridItem} width={[1, 1, 1 / 2]}>
            <Type bold className={styles.Title}>
              Version:{' '}
            </Type>
            <Type className={styles.MediaVersionData} color="teal">
              {details.version}
            </Type>
          </Grid.Item>
        )}
        {details.classificationUse && (
          <Grid.Item className={styles.GridItem} width={[1, 1, 1 / 2]}>
            <Type bold className={styles.Title}>
              Use:{' '}
            </Type>
            <Type color="teal" className={styles.MediaVersionData}>
              {details.classificationUse}
            </Type>
          </Grid.Item>
        )}
        {details.distributor && (
          <Grid.Item className={styles.GridItem} width={[1, 1, 1 / 2]}>
            <Type bold className={styles.Title}>
              Distributor:{' '}
            </Type>
            <Type color="teal" className={styles.MediaVersionData}>
              {details.distributor}
            </Type>
          </Grid.Item>
        )}
        {details.cutsSummary && (
          <Grid.Item className={styles.GridItem} width={[1]}>
            <Type bold className={styles.Title}>
              Cuts:{' '}
            </Type>
            <Type className={styles.MediaVersionData}>
              {details.cutsSummary}
            </Type>
          </Grid.Item>
        )}
        {details.rejectionExplanation && (
          <Grid.Item className={styles.GridItem} width={[1]}>
            <Type bold className={styles.Title}>
              Unsuitable for classification:{' '}
            </Type>

            <Type
              className={classNames(
                styles.MediaVersionData,
                styles.RejectionExplanation
              )}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: details.rejectionExplanation
                }}
              />
            </Type>
          </Grid.Item>
        )}
        {details.paperworkRemarks && (
          <Grid.Item className={styles.GridItem} width={[1]}>
            <Type bold className={styles.Title}>
              Paperwork Remarks:{' '}
            </Type>
            <Type className={styles.MediaVersionData}>
              {details.paperworkRemarks.length > 80
                ? details.paperworkRemarks.slice(0, 80) + '...'
                : details.paperworkRemarks}
            </Type>
          </Grid.Item>
        )}
      </Grid>
    </div>
  )
}

export default MediaVersionContent

MediaVersionContent.propTypes = {
  details: shape(mediaVersionPropTypes),
  designV2: bool
}
